/**
 * Aplica paginação ERP (cursor ou legado com count) em listagens BaseTable/Filter.
 *
 * @param {object} vm instância Vue (this)
 * @param {object|null|undefined} payload response.data.data
 * @param {number|string} page página 1-based da requisição
 * @param {number|string} perPage cTop / por_pagina
 * @param {number|null} previousPage página anterior 0-based (para toast ao avançar)
 */
export function applyErpPagination(vm, payload, page, perPage, previousPage = null) {
    const safePayload = payload ?? {};
    const perPageNum = Number(perPage) || 25;
    const pageNum = Number(page) || 1;

    let rows = safePayload.ZOOM;
    if (rows && !Array.isArray(rows)) {
        rows = Object.values(rows);
    }
    if (!Array.isArray(rows)) {
        rows = [];
    }

    vm.data = rows;

    const hasCursorMeta =
        safePayload.pagination === "cursor" ||
        typeof safePayload.has_next === "boolean";

    const hasLegacyCount =
        safePayload.count !== undefined &&
        safePayload.count !== null &&
        !Number.isNaN(Number(safePayload.count));

    if (hasCursorMeta || !hasLegacyCount) {
        vm.cursorPagination = true;
        vm.hasNext =
            typeof safePayload.has_next === "boolean"
                ? safePayload.has_next
                : rows.length >= perPageNum;
        vm.hasPrev =
            typeof safePayload.has_prev === "boolean"
                ? safePayload.has_prev
                : pageNum > 1;

        const apiPage =
            safePayload.page !== undefined && safePayload.page !== null
                ? Number(safePayload.page)
                : pageNum;
        vm.currentPage = Math.max(0, (Number.isNaN(apiPage) ? pageNum : apiPage) - 1);

        vm.maxPageReached = Math.max(vm.maxPageReached ?? 1, vm.currentPage + 1);

        const navigatedForward =
            previousPage !== null && pageNum > previousPage + 1;

        if (rows.length === 0 && pageNum > 1) {
            vm.$toast?.info("Última página");
            vm.hasNext = false;
        } else if (!vm.hasNext && navigatedForward) {
            vm.$toast?.info("Última página");
        }

        return;
    }

    vm.cursorPagination = false;
    vm.count = Number(safePayload.count);
    vm.currentPage = pageNum > 0 ? pageNum - 1 : 0;
    vm.lastPage = Math.max(1, Math.ceil(vm.count / perPageNum));

    if (vm.count < perPageNum) {
        vm.lastPage = 1;
    } else if (vm.count % perPageNum > 0 && vm.lastPage === 1) {
        vm.lastPage += 1;
    }
}
